import { render } from "./LayoutDefault.vue?vue&type=template&id=b32b42fa&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=b32b42fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32b42fa"]])

export default __exports__